import { css, type Theme } from "@emotion/react";
import { PlainButton } from "@turo/pedal";
import type { ComponentProps, FC } from "react";

/**
 * PlainButton has a height of 36px but the styling for this feature expects 32px. Margins are adjusted to resize.
 * {@link https://github.com/turo/design-system-frontend-core/blob/5803aff609569b90189f515324136a29d17e94e8/src/components/buttons/Button.styles.ts#L121}
 *
 * We also apply text-align: left to left-align the text in a flex column layout
 */
const otpPlainButtonStyles = (theme: Theme) => css`
  padding: ${theme.gutters.gutter_4} 0;
  text-align: left;
  white-space: normal;
`;

interface OTPPlainButtonProps extends ComponentProps<typeof PlainButton> {
  onClick: NonNullable<ComponentProps<typeof PlainButton>["onClick"]>;
}

/**
 * This is a component wrapper around Pedal's <PlainButton /> because the default padding
 * of that button is different than the OTP design. We normally need not painstakingly
 * implement a 2px padding difference, but the OTP implementation is a special case: we
 * need to manually set the height of the iframe (so every pixel counts), and since this is
 * the very top of the funnel it is perhaps more important to implement it exactly to spec.
 */
export const OTPPlainButton: FC<OTPPlainButtonProps> = ({
  children,
  isDisabled,
  onClick,
}) => {
  return (
    <PlainButton
      css={otpPlainButtonStyles}
      isDisabled={isDisabled}
      onClick={onClick}
      shouldHugContent
    >
      {children}
    </PlainButton>
  );
};
